import OnloadHandler from 'onload_handler';

export const CascadeField = function(){

    var thisField,
        thisFieldFilter,
        container,
        thatField,
        thatPath;

    function cf(){
    };

    function replaceThats(data){
      // Clear any populated options in the select box
      thatField.empty();

      // Add a placeholder
      var placeholder = $('<option></option>').attr("value", "").text("");
      thatField.append(placeholder);
      
      // var valid_data = _.filter(data, (el) => {
      //   if (!_.has(el, 'end_date')) return true;
      //   var d = new Date(el.end_date);
      //   return d >= new Date();
      // })
      //
      // var invalid_data = _.filter(data, (el) => {
      //   if (!_.has(el, 'end_date')) return false;
      //   var d = new Date(el.end_date);
      //   return d < new Date();
      // })
      //
      // // Add the states
      // _.each(valid_data, function(elem) {
      //   var option = $('<option></option>').attr("value", elem.id).text(elem.name);
      //   thatField.append(option);
      // })
      // if (invalid_data.length > 0) {
      //   var group = $('<optgroup label="Cessati"></optgroup>');
      //   _.each(invalid_data, function(elem) {
      //     var location_name = `${elem.name} (${elem.start_date} / ${elem.end_date})`;
      //     var option = $('<option></option>').attr("value", elem.id).text(location_name);
      //     group.append(option);
      //   })
      //   thatField.append(group);
      // }

      // Add the states
      _.each(data, function(elem) {
        var option = $('<option></option>').attr("value", elem.id).text(elem.full_name||elem.name);
        thatField.append(option);
      })
      thatField.change();

    }

    function reloadThats(){
      var filter = {};
      filter[thisFieldFilter] = thisField.val();
      $.ajax({
        url: thatPath,
        data: {
          q: filter
        },
        success: replaceThats
      });
    }

    cf.setup = function(fieldselector, fieldfilter) {
      thisFieldFilter = fieldfilter;
      thisField = $(fieldselector);
      container = document;
      if (thisField.data('container')) {
        container = thisField.closest(thisField.data('container'));
      }
      thatField = $(container).find(thisField.data('field'));
      thatPath = thatField.data('path');

      // Configure the events
      thisField.on('change', reloadThats);
    }

    return cf;
};

export const CountryField = function(){

    var thisField,
        container,
        abroadElement,
        italyElement;

    function cf(){
    };

    function toggleFields(){
      var val = thisField.find('option:selected').text();
      if (val === "") {
        italyElement.hide();
        abroadElement.hide();
      } else if (val === "ITALIA" ) {
        italyElement.show();
        abroadElement.hide();
      } else {
        italyElement.hide();
        abroadElement.show();
      }
    }

    cf.setup = function(fieldselector) {
      thisField = $(fieldselector);
      var italyElementSelector = thisField.data('group-italy');
      var abroadElementSelector = thisField.data('group-abroad');
      if (italyElementSelector && abroadElementSelector) {
        container = document;
        if (thisField.data('container')) {
          container = thisField.closest(thisField.data('container'));
        }
        italyElement = $(container).find(italyElementSelector);
        abroadElement = $(container).find(abroadElementSelector);
        thisField.on('change', toggleFields);
        toggleFields();
      }
    }

    return cf;
};

export const setupCountryCascade = function(el) {
  CascadeField().setup(el, 'country_id_eq');
  CountryField().setup(el);
}

export const setupCascade = function(el) {
  CascadeField().setup(el, 'province_id_eq');
}

